import { jsxs as c, jsx as r } from "@emotion/react/jsx-runtime";
import { Stack as n } from "@partoohub/ui";
import { NEWS_TYPE as a, ANNOUNCE_TYPE as p, HELP_TYPE as f } from "../../NotificationPanel.types.js";
import { InformationCard as m } from "../InformationCard/InformationCard.js";
const x = ({
  informations: e
}) => {
  const o = e?.items.filter((t) => t?.category === a), s = e?.items.filter((t) => t?.category === p), i = e?.items.filter((t) => t?.category === f);
  return /* @__PURE__ */ c(n, { gap: "8px", children: [
    /* @__PURE__ */ r(m, { items: o }),
    /* @__PURE__ */ r(m, { items: s }),
    /* @__PURE__ */ r(m, { items: i })
  ] });
};
export {
  x as InformationsCard
};
